export function envNumber(value?: string, defaultValue = 0): number {
  if (!value) {
    return defaultValue
  }
  return parseInt(value, 10)
}

export function envBoolean(value?: string, defaultValue = false): boolean {
  if (!value) {
    return defaultValue
  }
  return value === 'true' || value === '1'
}

export function envJson<T>(value: string | undefined, defaultValue: T): T {
  if (!value) {
    return defaultValue
  }
  return JSON.parse(value)
}
